import {getTranslation} from "./get-translation";
import {isIOS} from "./mobile";

const wrongAudio = new Audio(getTranslation("audio_wrong_answer"));

export function playWrongAudio(){
	wrongAudio.play();
}

export const correctAudio = new Audio(getTranslation("audio_correct"));

export function playCorrectAudio(){
	correctAudio.play();
}

export const unlockLevelAudio = new Audio(getTranslation("audio_unlock_level"));

export function playUnlockLevelAudio(){
	if(!isIOS()) {
		unlockLevelAudio.play();
	}
}

export function vibrateWrong(){
	window.navigator.vibrate([0, 150, 100, 50, 50, 220])
}

const winnerWheelAudio = new Audio(getTranslation(("audio_winner_wheel")));

export function playWinnerWheelAudio(){
	if(!isIOS()){
		winnerWheelAudio.play();
	}
}